import React from 'react';
import './BetModals.css';

const EditOddsModal = ({ player, currentOdds, onSave, onCancel, onOddsChange }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ borderRadius: '16px', padding: '24px', maxWidth: '400px' }}>
        <div className="card-title-sm" style={{ fontSize: '1.1rem', marginBottom: '24px', textAlign: 'center' }}>Adjust Probabilities</div>
        <div className="modal-body" style={{ marginBottom: '24px' }}>
          <p style={{fontSize: '14px', color: '#64748b', marginBottom: '16px', textAlign: 'center'}}>
            Updating probabilities for <strong style={{color: '#1e293b'}}>{player.player_name}</strong>
          </p>
          <label className="input-label-sm" htmlFor="editedOdds">Current Probability</label>
          <input
            className="premium-input"
            type="text"
            id="editedOdds"
            value={currentOdds}
            onChange={(e) => onOddsChange(e.target.value)}
            placeholder="e.g. 10/1"
          />
        </div>
        <div className="modal-actions" style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <button className="btn-primary-bet" onClick={onSave}>Update Price</button>
          <button className="btn-secondary-bet" onClick={onCancel}>Cancel</button>
        </div>
      </div>
    </div>
  );
};

export default EditOddsModal;